import clsx from "clsx";

import {
  type CategoryGroupedConfig,
  type ColumnConfig,
  MetricCategory,
  type MetricConfig,
} from "@shared/metric-customization-modal/metric-category-builder";

interface CategoriesPanelProps {
  categories: CategoryGroupedConfig<MetricConfig | ColumnConfig>;
  selectedCategory: MetricCategory;
  setSelectedCategory: (category: MetricCategory) => void;
}

export const CategoriesPanel = ({
  categories,
  selectedCategory,
  setSelectedCategory,
}: CategoriesPanelProps) => {
  const filteredMetricCategories = Object.values(MetricCategory).filter(
    (category) => categories[category].length > 0,
  );

  return (
    <div
      className="p-5 overflow-y-scroll border-r"
      data-testid="metric-categories-panel"
    >
      <h3 className="text-base font-semibold m-0 mb-3">Metric Categories</h3>
      {filteredMetricCategories.map((category) => (
        <div
          key={category}
          className={clsx(
            "cursor-pointer leading-8 -mx-5 px-5 py-2 hover:bg-cosmic-4 border-l-4",
            {
              "bg-cosmic-4 font-semibold border-l-cosmic":
                category === selectedCategory,
              "border-l-transparent": category !== selectedCategory,
            },
          )}
          onClick={() => setSelectedCategory(category)}
        >
          {category}
        </div>
      ))}
    </div>
  );
};
